import { alertService } from '../../services/alertService';

export class AlertNotificationStore {
  setErrorMessage(msg: string) {
    alertService.error(msg);
  }

  setSuccessMessage(msg: string) {
    alertService.success(msg);
  }

  setWarningMessage(msg: string) {
    alertService.warning(msg);
  }
}
